// export const parentAPI = "http://localhost/app/athlete/";
export const parentAPI = "https://beta.tenvicsports.com/app/athlete/";

// Register Athlete Basic Info
export const Athlete = parentAPI + "athlete";

// Register Athlete Gaurdian Info
export const AthleteGaurdianInfo = parentAPI + "athleteguardianinfo";

// Register Athlete Sport Info
export const AthleteSportInfo = parentAPI + "athletesportinfo";

// Athlete Login
export const AthleteLogin = parentAPI + "athlete-login";

// Athlete Profile
export const AthleteProfile = parentAPI + "profile-info";

// Menu List
export const GetUserMenus = parentAPI + "athlete-menu";

// Metrics data
export const AthleteMetricsData = parentAPI + "athletemetricdata";

// Metric scale
export const MetricScale = parentAPI + "metricscale";

// Create Metrics
export const CreateMetrics = parentAPI + "createmetrics";

// Onboard Medical History
export const OnboardBasicMedicalHistory = parentAPI + "onboardbasicmedicalhistory";

// Onboard Medical History
export const OnboardMedicalHistory = parentAPI + "onboardmedicalhistory";

// Add Medical Details
export const AddMedicalDetails = parentAPI + "addonboardmedicalhistory";

// Edit Medical Details
export const EditMedicalDetails = parentAPI + "editonboardmedicalhistory";

// Onboard Injury History
export const OnboardInjuryHistory = parentAPI + "onboardinjuryhistory";

// Add Injury Details
export const AddInjuryDetails = parentAPI + "addonboardinjuryhistory";

// Edit Injury Details
export const EditInjuryDetails = parentAPI + "editonboardinjuryhistory";

// Onboard Surgery History
export const OnboardSurgeryHistory = parentAPI + "onboardsurgeryhistory";

// Add Surgery Details
export const AddSurgeryDetails = parentAPI + "addonboardsurgeryhistory";

// Edit Surgery Details
export const EditSurgeryDetails = parentAPI + "editonboardsurgeryhistory";

// Onboard Physiological History
export const OnboardPhysiologicalHistory = parentAPI + "onboardphysiologicalhistory";

// Add Physiological Details
export const AddPhysiologicalDetails = parentAPI + "addonboardphysiologicalhistory";

// Edit Physiological Details
export const EditPhysiologicalDetails = parentAPI + "editonboardphysiologicalhistory";

// list, get, create, update, delete injury
export const Injury = parentAPI + "injury";

//list, get, create, update, delete injury-assessment
export const InjuryAssessment = parentAPI + "injury-assessment";

// list, get, create, update, delete injury diagnosis
export const InjuryDiagnosis = parentAPI + "diagnosis";

//list, get, create, update, delete injury treatment
export const InjuryTreatment = parentAPI + "treatmentplan";


// Blood Group
export const BloodGroup = parentAPI + "bloodgroup";

// Allergy Type
export const AllergyType = parentAPI + "allergytype";

// Medication Category
export const MedicationCtgry = parentAPI + "medicationcategory";

// Alcohol
export const Alcohol = parentAPI + "alcoholusage";

// Tobacco
export const Tobacco = parentAPI + "tobaccousage";

// Injury Type
export const InjuryType = parentAPI + "injurytype";

// Region Affected
export const RegionAffected = parentAPI + "regionaffected";

// Diagnosis Type
export const DiagnosisType = parentAPI + "diagnosistype";

// Injury Severity
export const InjurySeverity = parentAPI + "injuryseverity";

// Injury Mechanism
export const InjuryMechanism = parentAPI + "mechanisminjury";

// Injury Management Approach
export const InjuryManagement = parentAPI + "injurymanagementapproach";

// Time Lost
export const TimeLost = parentAPI + "timelostfromtraining";

// Surgery Category
export const SurgeryCategory = parentAPI + "surgerycategory";

// Body Region
export const BodyRegion = parentAPI + "bodyregion";

// Rehabilitation Duration
export const RehabilitationDuration = parentAPI + "rehabilitationduration";

// Physiological Type
export const PhysiologicalType = parentAPI + "physiologicaltype";

// list talent scouting
export const ListTalentScouting = parentAPI + "listtalentscouting";

// list batches
export const ListBatches = parentAPI + "listbatch";

// list batch athletes
export const ListBatchesAthletes = parentAPI + "listbatchathlete";

// list schedules
export const ListSchedules = parentAPI + "listschedule";

// list assessment
export const ListAssessments = parentAPI + "listassessment";

// Center Batch
export const CenterBatch = parentAPI + "centerbatch";

// Center Batch Athlete
export const CenterBatchAthlete = parentAPI + "centerbatchathlete";

// list center schedule
export const CenterSchedule = parentAPI + "centerschedule";

// list center attendance
export const CenterAttendance = parentAPI + "centerattendance";

// list Assessment
export const CenterAssessment = parentAPI + "centerassessment";

// list hpc batch
export const HPCBatch = parentAPI + "hpcbatch";

// list hpc batch athlete
export const HPCBatchAthlete = parentAPI + "hpcbatchathlete";

// list hpc schedule
export const HPCSchedules = parentAPI + "hpcschedule";

// list hpc attendance
export const HPCAttendance = parentAPI + "hpcattendance";

// list hpc assessment
export const HPCAssessment = parentAPI + "hpcassessment";

// list competition performance
export const competitionPerformance = parentAPI + "competitionperformance";

// external competition athletes
export const ExternalCompetitionAthletes = parentAPI + "extcomp_athletes";

// external competition sinclair constants
export const ExternalCompetitionSinclairConstants = parentAPI + "extcomp_sinclair_constants";

// list athletes by weight
export const ListAthletesByWeight = parentAPI + "getathletesbyweight";

// external competition events
export const ExternalCompetitionEvents = parentAPI + "extcomp_competition";

// external competition results
export const ExternalCompetitionResults = parentAPI + "extcomp_performance";

// external competition athlete competition entery
export const ExternalCompetitionAthleteEntry = parentAPI + "extcomp_athlete_competition_entery";

// external competition attempts
export const ExternalCompetitionAttempts = parentAPI + "extcomp_attempts";

// world record
export const WorldRecord = parentAPI + "extcomp_weightlifting_records";

// external competition analytics
export const ExternalCompetitionAnalytics = parentAPI + "ext_competitionanalytics";